<template>
  <b-checkbox
    v-model="item.total"
    :state="state && null"
    @input="$emit('toggle-total')"
  >
    {{ item.column }}
  </b-checkbox>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { FieldMapItem, FieldTypes } from '@/types'

const props = {
  item: {
    type: Object as PropType<FieldMapItem>,
    default: () => ({
      name: '',
      type: FieldTypes.STRING,
      unit: '',
      total: false,
      column: 'column',
    }),
  },
  state: Boolean,
}

@Component
export default class TotalItem extends Vue.extend({ props }) {}

</script>
